import { render, staticRenderFns } from "./rdfx.vue?vue&type=template&id=2af77058&scoped=true&"
import script from "./rdfx.vue?vue&type=script&lang=js&"
export * from "./rdfx.vue?vue&type=script&lang=js&"
import style0 from "./rdfx.vue?vue&type=style&index=0&id=2af77058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af77058",
  null
  
)

export default component.exports